module.exports = __webpack_public_path__ + "img/triangle.34ef38b2.svg";